import { render, staticRenderFns } from "./SectionWebtoons.vue?vue&type=template&id=45e6e7da&scoped=true"
import script from "./SectionWebtoons.vue?vue&type=script&lang=js"
export * from "./SectionWebtoons.vue?vue&type=script&lang=js"
import style0 from "./SectionWebtoons.vue?vue&type=style&index=0&id=45e6e7da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e6e7da",
  null
  
)

export default component.exports